import { Component, OnInit, Input } from '@angular/core';

@Component({
	selector: 'hedou-logo',
	templateUrl: './logo.component.html',
	styleUrls: ['./logo.component.less']
})
export class LogoComponent implements OnInit {

	headerLogo: string = 'http://192.168.3.252/publicData/images/logo.png';

	@Input() color: 'light' | 'dark' = 'dark';

	constructor() { }

	ngOnInit(): void {

	}

}
